import { Badge, type BadgeProps } from "@/components/ui/badge";
import { PROJECT_STATUS } from "@/config/projectStatus";

const STATUS_LABELS: Record<string, string> = {
  [PROJECT_STATUS.InProgress]: "Ready to Chat",
};

const STATUS_VARIANTS: Record<string, BadgeProps["variant"]> = {
  [PROJECT_STATUS.InProgress]: "success",
};

const StatusBadge = ({ status }: { status: string }) => {
  const variant = STATUS_VARIANTS[status] ?? "outline";
  return <Badge variant={variant}>{STATUS_LABELS[status] ?? status}</Badge>;
};

export default StatusBadge;
